import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
//OTHER IMPORTS
import dayjs from "dayjs";

//PROJECT IMPORTS
import styles from "../../../../../assets/styles/styles";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";

const AddSavingsAccCharge = (props) => {
  const { TextArea } = Input;
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [chargeId, setChargeId] = useState();
  const [feeIntervalValue, setFeeIntervalValue] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [chargesOptions, setChargesOptions] = useState([]);
  const [displayFields, setDisplayFields] = useState(false);
  const [dueDateNotRequired, setDueDateNotRequired] = useState(false);
  const [chargeTimeTypeAnnualOrMonth, setChargeTimeTypeAnnualOrMonth] =
    useState(false);
  const dateFormat = "DD-MM-YYYY";

  useEffect(() => {
    defaultDate();
    getTemplate();
  }, []);

  const defaultDate = () => {
    useForm.setFieldsValue({
      feeOnMonthDay: dayjs(),
      dueDate: dayjs(),
    });
  };

  function onCancel() {
    navigate("/detail-savings-account", { state: state });
  }
  const getTemplate = () => {
    const url = `${apiConfig.savingsAccounts}/${state.id}/charges/template`;

    let body = {
      session,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempCharges = [];

        objDetail?.chargeOptions?.forEach((element) => {
          tempCharges.push({
            value: element.id,
            label: element.name
              ? `${element.name} (${element.currency.name})`
              : "",
          });
        });

        setChargesOptions(tempCharges);

        setIsLoading(false);
      }
    });
  };

  const onChangeCharge = (chargeParam) => {
    setDueDateNotRequired(false);
    setChargeTimeTypeAnnualOrMonth(false);

    const params = {
      template: true,
    };
    const url = `${apiConfig.charges}/${chargeParam}`;
    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;

        useForm.setFieldsValue({
          amount: objDetail.amount,
          chargeCalculationType: objDetail?.chargeCalculationType?.value,
          chargeTimeType: objDetail?.chargeTimeType?.value,
        });

        if (
          objDetail?.chargeTimeType?.value?.toLowerCase() ===
            "withdrawal fee" ||
          objDetail?.chargeTimeType?.value?.toLowerCase() ===
            "saving no activity fee"
        ) {
          setDueDateNotRequired(true);
        }
        if (
          objDetail?.chargeTimeType?.value?.toLowerCase() === "annual fee" ||
          objDetail?.chargeTimeType?.value?.toLowerCase() === "monthly fee"
        ) {
          setChargeTimeTypeAnnualOrMonth(true);
        }

        setFeeIntervalValue(objDetail?.feeInterval);
        setChargeId(chargeParam);
        setDisplayFields(true);
        setIsLoading(false);
      }
    });
  };

  const onSubmit = (formValues) => {
    if (!dueDateNotRequired && !chargeTimeTypeAnnualOrMonth) {
      formValues.dateFormat = "dd MMMM yyyy";
      formValues.dueDate = formValues.dueDate
        ? BOM.DateTime(formValues.dueDate, "only-date")
        : formValues.dueDate;
    }
    if (!dueDateNotRequired && chargeTimeTypeAnnualOrMonth) {
      formValues.monthDayFormat = "dd MMMM";
      formValues.feeOnMonthDay = formValues.feeOnMonthDay
        ? BOM.DateTimeWithoutYear(formValues.feeOnMonthDay, "only-date")
        : formValues.feeOnMonthDay;
      formValues.feeInterval = feeIntervalValue;
    }
    delete formValues.chargeCalculationType;
    delete formValues.chargeTimeType;

    const url = `${apiConfig.savingsAccounts}/${state.id}/charges`;

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(
          cnt.SUCCESS,
          "Savings Account charge was succesfully added"
        );
        navigate("/detail-savings-account", {
          state: { ...state, statusValue: state?.statusValue.toLowerCase() },
        });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.addCharge}
        pageItems={staticConfig.addSavingsAccountChargeBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.charges}
                  name={"chargeId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld("Charges"),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.charge,
                      "select"
                    )}
                    onChange={onChangeCharge}
                    options={chargesOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              {displayFields && (
                <>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={
                        <Typography.Text style={{ fontSize: "16px" }}>
                          {labelConfig.amount}
                        </Typography.Text>
                      }
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld("Charges"),
                        },
                      ]}
                      name="amount"
                    >
                      <InputNumber
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.amount
                        )}
                        style={styles.ofInputFieldNumber}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.chargeCalculation}
                      name="chargeCalculationType"
                    >
                      <Select disabled />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.chargeTimeType}
                      name="chargeTimeType"
                    >
                      <Select disabled />
                    </Form.Item>
                  </Col>
                  {!dueDateNotRequired && !chargeTimeTypeAnnualOrMonth && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.dueForCollectionOn}
                        name={"dueDate"}
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(labelConfig.date),
                          },
                        ]}
                      >
                        <DatePicker style={{ width: "100%", height: 35 }} />
                      </Form.Item>
                    </Col>
                  )}
                  {!dueDateNotRequired && chargeTimeTypeAnnualOrMonth && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.dueOn}
                        name={"feeOnMonthDay"}
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(labelConfig.date),
                          },
                        ]}
                      >
                        <DatePicker style={{ width: "100%", height: 35 }} />
                      </Form.Item>
                    </Col>
                  )}
                </>
              )}
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default AddSavingsAccCharge;
